import wx from 'weixin-js-sdk';
import axios from 'axios';
import {ref} from 'vue';
import Md5 from 'js-md5';

const jsTicketURL = 'public/Wx/wx_signPack';
//---------------------------------
//是否是微信浏览器
const isWechat = () => {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/micromessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
};
//---------------------------------

/**
 * 获取微信配置
 * @param {*} share_title 分享标题
 * @param {*} share_desc 分享描述
 * @param {*} share_link 分享链接
 * @param {*} share_cover 分享封面（配图）
 * @returns
 */
const wxShare = (share_title, share_desc, share_link, share_cover) => {
      // var wx_host = window.location.href.split('#')[0]; //后端获取签名，需要前端传url
    let wx_host = "https://vote.cctvwenhua.tv/quyi/"; //后端获取签名，需要前端传url
    const share_img = share_cover || 'https://www.yishuyibao.com/share.png'; //不重要的默认图片地址
    return new Promise((resolve, reject) => {
          let share_link=window.location.href //动态传当前路由
        //  const timestamp = new Date().getTime()/1000;//时间戳
        axios.post(wx_host + jsTicketURL, {"url":share_link}).then((res) => {
            if (res.status == 200) {
                const config = {
                    appId: res.data.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.data.signature, // 必填，签名
                    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，注意查看官方文档，部分js接口即将废弃，我这里用的是新的
                    openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表（当前标签用于跳转微信小程序）
                };
                wx.config(config); //通过config接口注入权限验证配置
                wx.ready(function () { //通过ready接口处理成功验证
                    //分享给朋友
                    wx.updateAppMessageShareData({
                        title: share_title || document.title || "呵呵~", // 分享标题
                        desc: share_desc || document.description || document.title || "这家伙很懒,什么都没留下!", // 分享描述
                        link:share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: share_img, // 分享后显示的封面图
                        success: function () {
                            console.info("分享给朋友");
                        }, // 设置成功回调
                    });

                    //分享到朋友圈
                    wx.updateTimelineShareData({
                        title: share_title || document.title || "呵呵~", // 分享标题
                        link:share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: share_img, // 分享图标
                        success: function () {
                            // 用户点击了分享后执行的回调函数
                            console.info("分享到朋友圈");
                        }
                    })
                    console.log("js-sdk配置成功！");
                    return resolve(true)
                });
                wx.error(function (res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    console.info("config信息验证失败");
                    console.info(res);
                    return reject(false)
                });
            }
        });
    })
};
//--------------获取用户OPENID--------------
/*
* @param {*} data 数据
* @param {*} operation 加解密标识
* */
const hash_data = (data, operation) => {
    const key_get = (dstr) => {
        dstr = Md5(dstr + '_HashKey')
        return dstr.substr(0, 1) + dstr.substr(7, 1) + dstr.substr(3, 1) + dstr.substr(5, 1) + dstr.substr(9, 1)

    }
    if (operation == 'decode') {
        if (data.length < 6) {
            return '';
        }
        let str = data.substr(0, data.length - 5);
        let enkey = key_get(Md5(str));
        if (enkey == data.substr(data.length - 5)) {
            return data.substr(data.length - 5);
        }
        return '';
    } else if (operation == 'encode') {
        if (data.length < 1) {
            return '';
        }
        let enkey = key_get(Md5(data));
        return data + enkey;
    } else {
        return data;
    }

}
//--------------获取用户OPENID--------------
const getOpenid = () => {
    localStorage.removeItem('openid');

};
//----------------------------
// const submitOrder=()=>{};
//
//----------------------------
const wxOauth = () => {
    const appId = "wxb079ec102fdec136"; // 这里是服务号或者公众号的唯一ID，去公众平台去查看
    let origin = window.location.origin;
    if (origin == undefined) {
        origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
//---------------------------------
//回调地址
    // origin="工程回调地址";
    const redirectUri = encodeURIComponent(origin); // 回调地址，获取到 code 之后重定向的 URL
// /**
//  用 snsapi_base 时不会弹出授权页面，仅返回 openid。使用 snsapi_userinfo 可以获取用户详细信息，但会弹出授权页面。
//  */
    const scope = "snsapi_userinfo"; // 这里我们使用 snsapi-userinfo，你也可以按需使用snsapi_base
    const code = ref(null); // 保存 code
    const openid = ref(null); // 保存 openid
    const state = encodeURIComponent(
        btoa(JSON.stringify({"hash": "My_wx_oauth" + window.location.hash}))
    );   // state 将保存当前页面的哈希信息，并以 URL 安全的格式传递到微信服务器
    const redirectToWeChatAuth = () => {
        if (openid.value == '' && openid.value.length > 10) {
            const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
// 这里就是授权了，如果配置没有问题，这一步就能获取到code，并且会并拼接到上面的redirectUri也就是你当前的回调地址，比如 https://www.baidu.com?code=xxxxxx
            window.location.href = authUrl;
        }
    }
//获取当前链接上面参数的方法
    const getQueryParam = param => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param); // 如果参数不存在，将返回 null
    };

    code.value = getQueryParam("code") //得到 code 的参数值
// //下面就需要后端配置了，我们将 code 提交到后端，后端那边就通过 code 去获取到每个用户的 openid
//
    if (code.value && getQueryParam("state") == state) {
        // 先判断，如果 URL 中有 code，调用接口
        //getOpenid 就是后端提供的接口，我们将 code参数提交给他
        getOpenid(code.value).then(res => {
            if (res.code == 200) {
                openid.value = res.msg; //已经成功获取到了 openid
                const ttl = 4 * 60 * 60 * 1000; // 4个小时

                setWithExpiry("openid", res.msg, ttl)
                console.log("openid 已保存:", openid.value);
            } else {
                //这个方法别忘了是上面获取 code 的方法
                //这里是为了防止我们获取 code 的时候错误导致无法将参数值传递给后端，我们就去循环获取 code，确保 code 不会获取失败， openid 才能正常获取
                //openid 很重要，也是我们支付不可缺失的一部分
                redirectToWeChatAuth();
                console.error("获取 openid 失败:", res.msg);
            }
        });
    } else {
        // 如果没有 code，跳转到微信授权页面，同上
        const hash_openid = getWithExpiry("openid"); //本地openid
        if (hash_openid) {
            openid.value = hash_data(hash_openid, 'decode');
        }
        redirectToWeChatAuth();
    }

    // 存储带有过期时间的数据
    const setWithExpiry = (key, value, ttl) => {
        const now = new Date();
        // ttl 是过期时间（单位：毫秒）
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    // 获取数据，检查是否过期
    const getWithExpiry = (key) => {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }

// 使用示例
//     const key = 'myData';
//     const value = 'dataValue';
//     const ttl = 30 * 60 * 1000; // 30 分钟
//
//     setWithExpiry(key, value, ttl);
//
//     const data = getWithExpiry(key);
//     console.log(data); // 如果数据未过期，打印出数据值；如果过期，打印 null


// //---------------
// submitOrder({
//     prise: 10, //价格
//     payType: "WECHAT",//表示是微信支付标识
//     title: "支付商品标题",
//     description: "支付商品描述",
//     openid: localStorage.getItem("openid") || "", //这里我们就将 openid传给后端，必填
// }).then(res => {
//     if (res.code == 200) {
//         //进来了，说明后端已经可以给我们返回拉起支付所需的参数了
//         wx.config({
//             debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
//             appId: res.data.appId, // 必填，公众号的唯一标识
//             timestamp: res.data.timestamp, // 必填，生成签名的时间戳
//             nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
//             signature: res.data.paySign, // 必填，签名
//             jsApiList: ["chooseWXPay", "checkJsApi"] // 必填，需要使用的JS接口列表
//         });
//
//         wx.ready(() => {
//             wx.chooseWXPay({
//                 appId: res.data.appId,// 必填，公众号的唯一标识
//                 timestamp: res.data.timestamp,// 必填，生成签名的时间戳
//                 nonceStr: res.data.nonceStr,// 必填，生成签名的随机串
//                 package: res.data.packageVal,// 统一支付接口返回的prepay_id参数值，提交格式如:prepay_id=|*|*|*)
//                 signType: res.data.signType,// 签名方式，根据后端返回就行，一般默认为'SHA1'，使用新版支付需传入'MD5'
//                 paySign: res.data.paySign, // 必填，支付签名
//                 success: function (payRes) {
//                     // 支付成功后的回调函数
//                     showToast("支付成功");
//                 },
//                 cancel: function (payRes) {
//                     // that.$message.error('取消支付')
//                     showToast("取消支付");
//                 },
//                 fail: function (payRes) {
//                     // that.$message.error('支付失败')
//                     showToast("支付失败");
//                 }
//             });
//         });
//     }
// })
//


};


export {isWechat, wxShare, wxOauth}